import React from 'react';
import { isStaff } from '../utils/roles';

interface DragonStatueProps {
  role?: string;
  onOpenMirror: () => void;
  onOpenForge: () => void;
}

const DragonStatue: React.FC<DragonStatueProps> = ({ role, onOpenMirror, onOpenForge }) => {
  const canSee = isStaff(role);
  
  if (!canSee) return null;

  return (
    <div className="fixed bottom-4 right-4 md:bottom-10 md:right-10 z-[200] flex gap-4 md:gap-8 items-end pointer-events-none">
      
      {/* SMEDJEN (Forge) - Hammer Ikon */}
      <div 
        className="pointer-events-auto cursor-pointer group flex flex-col items-center relative"
        onClick={(e) => { 
          e.stopPropagation(); 
          onOpenForge(); 
        }}
      >
        <div className="absolute inset-0 bg-orange-600/20 blur-xl rounded-full group-hover:bg-orange-500/40 transition-all duration-700 animate-pulse scale-110" />
        <div className="relative w-12 h-12 md:w-20 md:h-20 flex flex-col items-center justify-center transform group-hover:scale-110 transition-all duration-300">
           <span className="text-2xl md:text-5xl drop-shadow-[0_0_15px_rgba(234,88,12,0.7)] mb-1">⚒️</span>
           <div className="px-2 py-0.5 bg-black/80 border border-orange-500/50 rounded-full text-[6px] md:text-[7px] font-black uppercase tracking-[0.1em] text-orange-400 shadow-xl whitespace-nowrap">
             Smedjen
           </div>
        </div>
      </div>

      {/* VOGTER-SPEJLET - Spejl Ikon */}
      <div 
        className="pointer-events-auto cursor-pointer group flex flex-col items-center relative"
        onClick={(e) => { 
          e.stopPropagation(); 
          onOpenMirror(); 
        }}
      >
        <div className="absolute inset-0 bg-yellow-500/20 blur-2xl rounded-full group-hover:bg-yellow-400/40 transition-all duration-1000 animate-pulse scale-125" />
        <div className="relative w-14 h-18 md:w-24 md:h-32 flex flex-col items-center justify-center transform group-hover:scale-110 transition-all duration-500">
          <svg viewBox="0 0 100 120" className="w-10 h-12 md:w-20 md:h-24 drop-shadow-[0_0_15px_rgba(234,179,8,0.5)]">
            <path d="M50 10 L70 40 L50 30 L30 40 Z" fill="#ea6408" className="animate-bounce" style={{ animationDuration: '3s' }} />
            <path d="M20 100 Q50 120 80 100 L80 60 Q50 40 20 60 Z" fill="#1e1b4b" stroke="#ca8a04" strokeWidth="2" />
            <path d="M35 70 Q50 60 65 70" fill="none" stroke="#eab308" strokeWidth="1" opacity="0.5" />
            <circle cx="40" cy="55" r="2" fill="#eab308" className="animate-pulse" />
            <circle cx="60" cy="55" r="2" fill="#eab308" className="animate-pulse" />
          </svg>
          <div className="mt-1 px-2 py-0.5 bg-black/80 border border-yellow-500/50 rounded-full text-[6px] md:text-[8px] font-black uppercase tracking-[0.1em] text-yellow-500 shadow-xl whitespace-nowrap">
            Vogter-Spejlet
          </div>
        </div>
      </div>
    </div>
  );
};

export default DragonStatue;